import React, { useEffect, useState } from "react";
import { apiGet } from "../../../services/api";
import "./consultants.css";

interface Consultant {
  id: number;
  name: string;
  specialization?: string;
}

interface ConsultantListProps {
  selected?: Consultant | null;
  onSelect: (c: Consultant) => void;
}

export default function ConsultantList({ selected, onSelect }: ConsultantListProps) {
  const [rows, setRows] = useState<Consultant[]>([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    apiGet("/api/admin/consultants")
      .then((data: unknown) => {
        if (mounted) setRows(Array.isArray(data) ? (data as Consultant[]) : []);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        if (mounted) setLoading(false);
      });
      
    return () => { mounted = false; };
  }, []);

  const filtered = rows.filter(c =>
    c.name.toLowerCase().includes(search.toLowerCase()) || 
    (c.specialization || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: 'var(--mod-shadow-sm)' }}>
      {/* Header & Search */}
      <div style={{ padding: '20px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc' }}>
        <h3 style={{ margin: '0 0 12px 0', fontSize: '1.1rem', color: '#0f172a', display: 'flex', alignItems: 'center', gap: '8px' }}>
          👨‍⚕️ Consultants
        </h3>
        <div style={{ position: 'relative' }}>
            <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }}>🔍</span>
            <input
              placeholder="Search consultants..."
              value={search}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
              style={{ width: '100%', padding: '10px 14px 10px 36px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '0.9rem', boxSizing: 'border-box', outline: 'none' }}
            />
        </div>
      </div>

      {/* List */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#94a3b8' }}>Loading...</div>
        ) : filtered.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#94a3b8' }}>No consultants found</div>
        ) : (
          <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
            {filtered.map((c) => (
              <li
                key={c.id}
                onClick={() => onSelect(c)}
                style={{ 
                    padding: '16px 20px', 
                    borderBottom: '1px solid #f1f5f9', 
                    cursor: 'pointer', 
                    transition: 'all 0.2s',
                    background: selected?.id === c.id ? '#f0f9ff' : 'transparent',
                    borderLeft: selected?.id === c.id ? '4px solid #0ea5e9' : '4px solid transparent'
                }}
                onMouseEnter={(e) => {
                    if (selected?.id !== c.id) e.currentTarget.style.background = '#f8fafc';
                }}
                onMouseLeave={(e) => {
                    if (selected?.id !== c.id) e.currentTarget.style.background = 'transparent';
                }}
              >
                <div style={{ fontWeight: 600, color: selected?.id === c.id ? '#0369a1' : '#334155', fontSize: '1rem', marginBottom: '4px' }}>
                  {c.name}
                </div>
                <div style={{ fontSize: '0.85rem', color: '#64748b' }}>
                  {c.specialization || "General Specialist"}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
